import React from "react";

export default function render(value) {
    if(!!value) {
        return (<a href={`mailto:${value}`} title={`Email ${value}`}>{value}</a>)
    }
    
    return value;
}